import React, { useState, useEffect } from "react";
import Header from "../header/header";
import Footer from "../Footer";
import { ClipLoader } from "react-spinners";

const Loans: React.FC = () => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("doyen-access-dataform")) {
      localStorage.removeItem("doyen-access-dataform");
    }
    if (localStorage.getItem("installmentpresent")) {
      localStorage.removeItem("installmentpresent");
    }
  }, []);

  const toGmailsite = () => {
    window.open(
      "https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=info.academy@gmail.com",
      "_blank"
    );
  };

  const loadings = () => {
    new Promise((r) => setTimeout(r, 205));
    setReady(true);
  };

  useEffect(() => {
    loadings();
  }, []);

  return (
    <div>
      {ready ? (
        <>
          <Header />
          <div className="container">
            <br />
            <br />
            <br />
            <br />

            <div className="row">
              <div className="col-md-6">
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />

                <h3>Page not Available Yet. But Gbenga is;</h3>
                <p>
                  Gbenga is a Director who will be happy to meet you and discuss
                  your business needs. Message him at{" "}
                  <a
                    style={{ textDecoration: "none" }}
                    href="https://api.whatsapp.com/send?phone=37256704920"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src="../../images/whatsapp.png"
                      style={{
                        marginRight: "10px",
                        marginLeft: "10px",
                        height: "20px",
                        display: "inline",
                      }}
                      alt="whatsap"
                    />
                    <span style={{ color: "#0000FF", cursor: "pointer" }}>
                      +372 5670 4920 +2347033416581
                    </span>
                    .
                  </a>
                </p>
                <p>
                  or you can email us through{" "}
                  <p
                    style={{
                      color: "#0000FF",
                      display: "inline",
                      cursor: "pointer",
                    }}
                    onClick={toGmailsite}
                  >
                    info.academy@gmail.com
                  </p>
                  .
                </p>

                <p>
                  But if you’re more interested in IT than in Gbenga, try the
                  links below:
                </p>
                <a href="/">Doyenify Home</a>
              </div>
              <div className="col-md-6 text-center">
                <br />

                <br />
                {/* <div className='caption-wrapper'>
                                <div className='img-wrapper'><img src="../../images/oluyide.jpg" alt="int"></img></div>
                                
                            </div> */}
                <img
                  src="../../images/oluyide.jpg"
                  alt="int"
                  style={{ width: "100%", borderRadius: "10px" }}
                ></img>
              </div>
            </div>

            <br />
            <br />
            <br />
          </div>
          <br />
          <br />

          <Footer />
        </>
      ) : (
        <>
          <div>
            {/* <Audio
                        height="80"
                        width="80"
                        // radius="9"
                        color="green"
                        ariaLabel="loading"
                        wrapperStyle={{alignItems: "center", justifyContent: "center",verticalAlign: "middle", margin: "auto", position: "absolute",
                        top: "0", left: "0", bottom: "0", right: "0"}}
                        // wrapperClass
                        /> */}

            <div className="academystyle">
              <img src="../../images/doyenifyAcademy.png" alt="doy academy" />
              <ClipLoader size={25} color="#047E35" />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Loans;
